import { FormItem } from '@framework/form/item/FormItem.tsx';
import { TbIcon } from '@framework/ui/components/icon/TbIcon.tsx';
import { RowElement } from '@framework/ui/components/row/RowElement.tsx';
import { yup } from '@framework/validation/initYup.ts';
import { IconBolt } from '@tabler/icons-react';
import { RichTextAdvancedSchema } from '../../../../../inputs/rich-text-advanced/schema/RichTextAdvancedSchema.ts';
import { type IWidgetComponentProps } from '../../../IWidgetType.ts';
import { WidgetType } from '../../../Widget.ts';
import { AlignmentSelectInput } from '../../common/AlignmentSelectInput.tsx';
import { ButtonTypeSelectInput } from '../../common/ButtonTypeSelectInput.tsx';
import { type IWidgetConfigurationSlot } from '../../common/config-slots/IWidgetConfigurationSlot.ts';
import { WidgetConfigurationSlotRender } from '../../common/config-slots/WidgetConfigurationSlotRender.tsx';
import { IconTypeSelectInput } from '../../common/IconTypeSelectInput.tsx';
import { CommonBaseLayoutSchema } from '../../graphics/common/CommonBaseLayoutSchema.tsx';
import {
  CommonConfigComponent,
  CommonInputWidgetConfigSchema,
} from '../../inputs/common/CommonInputConfigComponent.tsx';
import { getWidgetProps } from '../../inputs/common/util/getWidgetProps.ts';
import { ButtonActionSchema } from './actions/ButtonActionSchema.ts';
import { ButtonActionsConfig } from './actions/ButtonActionsConfig.tsx';
import { type IButtonWidget } from './IButtonWidget.ts';
import { IconType } from './icons/Icons.tsx';
import { ButtonAlign, ButtonType } from './types/ButtonEnums.ts';

/** Card "Azioni del Pulsante". */
const ButtonActionsSlot: IWidgetConfigurationSlot = {
  key: 'button-actions',
  title: 'Azioni del Pulsante',
  icon: <TbIcon icon={IconBolt} />,
  description: 'Azioni eseguite dal pulsante al click.',
  order: 15,
};

export const ButtonWidgetConfigSchema: yup.ObjectSchema<IButtonWidget> =
  CommonInputWidgetConfigSchema.shape({
    type: yup.string().exact(WidgetType.Button).required(),
    label: RichTextAdvancedSchema.optional().label('Etichetta'),

    // Azioni
    actions: yup.array(ButtonActionSchema).notRequired().label('Azioni'),

    layout: CommonBaseLayoutSchema,
  });

export interface IButtonWidgetConfigComponentProps
  extends IWidgetComponentProps<IButtonWidget> {}

export function ButtonWidgetConfigComponent(
  props: IButtonWidgetConfigComponentProps,
) {
  const options = getWidgetProps(props);
  return (
    <>
      {/* Configurazioni comuni */}
      <CommonConfigComponent
        {...props}
        hideConfigPlaceholder={true}
        hideConfigDefaultValue={true}
      />

      <RowElement>
        <FormItem name="layout.buttonType" label="Tipo di pulsante">
          <ButtonTypeSelectInput
            name="layout.buttonType"
            defaultValue={ButtonType.Primary}
            placeholder="Seleziona il tipo di pulsante"
          />
        </FormItem>
        <FormItem name="layout.iconType" label="Icona del pulsante">
          <IconTypeSelectInput
            name="layout.iconType"
            defaultValue={IconType.Nessuna}
            placeholder="Seleziona l'icona del pulsante"
          />
        </FormItem>
        <FormItem name="layout.buttonAlign" label="Allineamento pulsante">
          <AlignmentSelectInput
            name="layout.buttonAlign"
            defaultValue={ButtonAlign.End}
            placeholder="Seleziona l'allineamento"
          />
        </FormItem>
      </RowElement>
      <WidgetConfigurationSlotRender slot={ButtonActionsSlot}>
        <FormItem name="actions">
          <ButtonActionsConfig name="actions" />
        </FormItem>
      </WidgetConfigurationSlotRender>
    </>
  );
}
